var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentForm2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83337 1.5C9.87758 1.5 9.91997 1.51756 9.95123 1.54882C9.98248 1.58007 10 1.62246 10 1.66667V5.43133C10 5.70733 10.224 5.93133 10.5 5.93133H13.5C13.5442 5.93133 13.5866 5.94889 13.6179 5.98015C13.6491 6.0114 13.6667 6.0538 13.6667 6.098V12.6667C13.6667 13.1529 13.4736 13.6192 13.1297 13.963C12.7859 14.3068 12.3196 14.5 11.8334 14.5H5.16671C4.68048 14.5 4.21416 14.3068 3.87034 13.963C3.52653 13.6192 3.33337 13.1529 3.33337 12.6667V3.33333C3.33337 2.8471 3.52653 2.38079 3.87034 2.03697C4.21416 1.69315 4.68048 1.5 5.16671 1.5H9.83337Z",
    fill: "#004529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.224 1.75896C11.1287 1.6823 11 1.7603 11 1.88296V4.76496C11 4.85696 11.0747 4.93163 11.1667 4.93163H13.3653C13.444 4.93163 13.4933 4.84896 13.448 4.78496L11.4387 1.98696C11.3774 1.90191 11.3052 1.82526 11.224 1.75896Z",
    fill: "#004529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentForm2);
export default __webpack_public_path__ + "static/media/paymentForm2.72bf66ae16c3fbcf554cda340a9630d1.svg";
export { ForwardRef as ReactComponent };